<style>
  .screen {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: all 500ms ease-out;
  }

	.isRunning {
		background: rgb(33,204,160);
		background-image: linear-gradient(90deg, rgba(33,204,160,1) 0%, rgba(0,255,190,1) 100%);
	}

	.isBreak {
		background-image: linear-gradient(to right, #941822, #ff6b6b);
	}
</style>
<script>
  export let state = 'default';
</script>

<div class="screen" class:isRunning={state === 'round'} class:isBreak={state === 'break'}>
  <slot></slot>
</div>
